const ID = '([A-Za-z0-9_-]{11})';
const PATTERNS = [
  new RegExp(`(?:^|//|\\.)(?:www\\.|m\\.)?youtube\\.com/watch\\?(?:[^#]*&)?v=${ID}(?![A-Za-z0-9_-])`),
  new RegExp(`(?:^|//|\\.)(?:www\\.|m\\.)?youtube\\.com/(?:embed|shorts|live)/${ID}(?![A-Za-z0-9_-])`),
  new RegExp(`(?:^|//)youtu\\.be/${ID}(?![A-Za-z0-9_-])`),
];

export function parseYouTubeId(url) {
  if (typeof url !== 'string') return null;
  const value = url.trim();
  if (!value) return null;
  for (const pattern of PATTERNS) {
    const match = value.match(pattern);
    if (match) return match[1];
  }
  return null;
}

export function isYouTubeUrl(url) {
  return parseYouTubeId(url) !== null;
}

export function youtubeThumbnailCandidates(id) {
  return ['sddefault', 'hqdefault', 'mqdefault'].map(q => `https://i.ytimg.com/vi/${id}/${q}.jpg`);
}

export async function fetchYouTubeTitle(url, { fetchImpl, timeoutMs = 4000 } = {}) {
  const doFetch = fetchImpl || (typeof window !== 'undefined' ? window.fetch.bind(window) : null);
  if (!doFetch) return null;
  const endpoint = `https://noembed.com/embed?url=${encodeURIComponent(url)}`;
  let timer;
  try {
    const response = await Promise.race([
      doFetch(endpoint),
      new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('timeout')), timeoutMs); }),
    ]);
    if (!response || !response.ok) return null;
    const json = await response.json();
    return typeof json.title === 'string' && json.title.trim() ? json.title.trim() : null;
  } catch (e) {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
